import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PayslipTable from './PayslipTable';
import CreatePayslip from './CreatePayslip';
import useFetchData from '../../hooks/useFetchData';

export default function PayslipMain() {
  const [createDialogVisible, setCreateDialogVisible] = useState(false);
  const { data: payslipData, loading, executeFetch } = useFetchData();
  const { t } = useTranslation();

  useEffect(() => {
    executeFetch("POST", "payslips/list", { page: 1, per_page: 10 });
  }, [executeFetch]);

  const handlePageChange = (newPage, newRowsPerPage) => {
    executeFetch("POST", "payslips/list", { page: newPage, per_page: newRowsPerPage });
  };

  const handleRefresh = () => {
    executeFetch("POST", "payslips/list", { page: 1, per_page: 10 });
  };

  return (
    <>
      <div>
        <PayslipTable
          data={payslipData}
          loading={loading}
          onPageChange={handlePageChange}
          onRefresh={handleRefresh}
        />
        <CreatePayslip
          setCreateDialogVisible={setCreateDialogVisible}
          createDialogVisible={createDialogVisible}
          onRefresh={handleRefresh}
        />
      </div>
    </>
  );
}
